import React, { Fragment, useEffect, useState } from 'react'
import { Box, Button, Grid, Paper, TextField } from '@mui/material'
import { useStyles } from './styles'
import {
  PickingValidateHeader,
  PickingValidateSkuDetail
} from '../../../interfaces/Picking/Picking'
import { GenericTable } from '../../_EOS/Table/GenericTable'
import { clsAlphaNoOnly } from '../../../utils/regex/regexFunctions'
import { usePagination } from '../../../hooks/usePagination'
import { useApi } from '../../../hooks/useApi'
import { getValidateFinishDetail } from './api'
import { Status } from '../../../hooks/useFetchState'
import { PickingValidateFinishDetailProps } from './typings'
import { positionAlertsDetailsHeaderConfig } from './FinishDetailComponent/component'

export const PickingValidateFinishDetail: React.FC<
  PickingValidateFinishDetailProps
> = ({ pickingRouteId }) => {
  const classes = useStyles()
  const { state, callApi } = useApi<{ data: PickingValidateHeader }>()
  const [sku, setSku] = useState<string>('')
  const [skuFilter, setskuFilter] = useState<string>('')
  const [statusFilter, setStatusFilter] = useState<string>('')

  // metodos para api
  const requestDataFinishDetail = (page?: number, pageSize?: number) => {
    callApi(
      getValidateFinishDetail(
        skuFilter,
        pickingRouteId,
        statusFilter,
        page,
        pageSize
      )
    ).catch((error) => {
      console.log(error)
    })
  }

  const pagination = usePagination(5)

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    requestDataFinishDetail(auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  const handleChangeSku = (e: any) => {
    setSku(e.target.value)
  }

  const handleSearchSku = async (pSku: string, pStatusfilter: string) => {
    pagination.setPagination(0, pagination.pageSize)

    // limpia control del sku
    if (pSku === '') {
      setSku('')
    }
    setskuFilter(pSku)
    setStatusFilter(pStatusfilter)
  }

  // Busca cuando cambian los filtros
  useEffect(() => {
    requestDataFinishDetail(pagination.page, pagination.pageSize)
  }, [skuFilter, statusFilter])

  return (
    <Fragment>
      <Paper style={{ marginBottom: '10px', padding: '16px' }}>
        <Grid container spacing={2} alignItems='center' justify='space-between'>
          {/* texto alineado a la izquierda */}
          <Grid item xs={6}>
            <TextField
              id='skuId'
              name='skuId'
              label='Buscar Producto'
              autoComplete='off'
              autoFocus
              value={sku}
              onChange={(e: any) => {
                handleChangeSku(e)
                clsAlphaNoOnly(e)
              }}
              onKeyPress={(evt: any) => {
                const keyCode = evt
                  ? evt.which
                    ? evt.which
                    : evt.keyCode
                  : evt.keyCode
                if (keyCode === 13) {
                  handleSearchSku(sku, '')
                }
              }}
              inputProps={{
                maxLength: 30,
                pattern: '[a-zA-Z0-9-]'
              }}
            />
            <Button
              type='submit'
              variant='contained'
              color='primary'
              className={classes.button}
              onClick={() => {
                handleSearchSku(sku, '')
              }}
            >
              {'BUSCAR'}
            </Button>
          </Grid>

          <Grid
            item
            xs={6}
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <Button
              type='submit'
              variant='contained'
              className={`${classes.button} ${classes.warning} ${classes.filterButton}`}
              onClick={() => {
                handleSearchSku('', '')
              }}
            >
              {'Limpiar Filtro'}
            </Button>
            <Button
              type='submit'
              variant='contained'
              className={`${classes.button} ${classes.sucess} ${classes.filterButton}`}
              id='btnCompleto'
              name='btnCompleto'
              value={'1-2'}
              onClick={() => {
                handleSearchSku('', '1-2')
              }}
            >
              {'Completo'}
            </Button>

            <Button
              type='submit'
              variant='contained'
              className={`${classes.button} ${classes.difference} ${classes.filterButton}`}
              name='btnDiferencia'
              id='btnDiferencia'
              value={'3-4'}
              onClick={() => {
                handleSearchSku('', '3-4')
              }}
            >
              {'Con Diferencias'}
            </Button>

            <Button
              type='submit'
              variant='contained'
              color='secondary'
              className={`${classes.button} ${classes.filterButton} ${classes.manage}`}
              id='btnGestionado'
              name='btnGestionado'
              value={'2-4'}
              onClick={() => {
                handleSearchSku('', '2-4')
              }}
            >
              {'Gestionado'}
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Paper>
        <Box>
          <Grid
            container
            spacing={2}
            alignContent='center'
            style={{ marginTop: '10px', marginBottom: '5px' }}
          >
            <Grid item xs={12} sm container>
              <Grid item xs={12} container direction='column' spacing={2}>
                <Grid item xs>
                  <GenericTable<PickingValidateSkuDetail>
                    headersConfig={positionAlertsDetailsHeaderConfig}
                    IDKey={'skuId'}
                    data={state.data?.data?.skuDetail}
                    pagination={{
                      totalItem: state.data?.data.totalSku || 0,
                      page: pagination.page,
                      pageSize: pagination.pageSize
                    }}
                    isLoading={state.status === Status.Loading}
                    onPaginationChange={handlePaginationChange}
                    showCheckboxes={false}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Fragment>
  )
}
